import "@coreui/coreui/dist/css/coreui.min.css";
import styles from "./location.module.css";

function Location() {
  return (
    <div className={styles.locationContainer}>
      <div className={styles.locationInfo}>
        <h1 className={styles.title}>Iglesia</h1>
        <p>De Los Olivos 66, Lázaro Cárdenas, 72805 San Andrés Cholula, Pue.</p>
        <h1 className={styles.title}>Horarios</h1>
        <p><label className={styles.reunion}>Shabat</label> - Viernes 7:45 PM</p>
        <p><label className={styles.reunion}>Oración</label> - Domingo 9 AM</p>
        <p><label className={styles.reunion}>Circulo de estudio</label> - Domingo 9 AM, Martes 6:45 PM y 8 PM</p>
        <p><label className={styles.reunion}>Discipulado</label> - Domingo 10:30 AM</p>
        <p><label className={styles.reunion}>General</label> - Domingo 11 AM</p>
      </div>

      <div style={{width:"15%"}}>

  
      </div>

      <div className={styles.locationMap}>
        <iframe
          title="Colectivo Siete Location Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2375.601897686826!2d-98.2935823184647!3d19.062286502496868!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85cfc7dc8c3e1c51%3A0x541f681b3511d7b8!2sColectivo%20Siete!5e0!3m2!1sen!2smx!4v1741749669178!5m2!1sen!2smx"
          width="50%"
          height="100%"
          frameBorder="0"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
}

export default Location;
